import script from "./detail-repair-record.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail-repair-record.vue?vue&type=script&lang=ts&setup=true"

import "./detail-repair-record.vue?vue&type=style&index=0&id=540dfe1a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540dfe1a"]])

export default __exports__